import { Grid } from '@/common/grid/Grid';
import { useModuleFromRoute } from '@/common/hooks/route/useModuleFromRoute';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Split } from '@/common/split/Split';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ValList } from '@/common/val/ValList';
import { Box } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';

export const SubValList = ({ parentEntityId }) => {
  const [selectedVal, setSelectedVal] = useState();
  const [fieldDefs, setFieldDefs] = useState();

  const gridRef = useRef();
  const rsrc = useRsrc();

  const module = useModuleFromRoute();

  const handleSelect = useCallback((val) => {
    setSelectedVal(val);
  }, []);

  const viewerReqParam = (operation) => ({
    id: parentEntityId,
    valCode: selectedVal.code,
    valParams: selectedVal.valParams,
    entity: 'SUB',
    viewerPluginCode: 'SUB_VAL_VIEWER_PLUGIN',
    operation,
  });

  const onGridReady = (params) => {
    const dataSource = {
      getRows: (params) => {
        const expr = ExprUtils.filterModelToExpr(params.filterModel, fieldDefs);
        const reqParam = {
          ...viewerReqParam('ROWS'),
          rowsReq: {
            startRow: params.startRow,
            endRow: params.endRow,
            expr,
            sortModel: params.sortModel,
          },
        };

        rsrc.data(module, 'VIEWER_DATA_PLUGIN', reqParam, 'SUB').then((res) => {
          gridRef.current.onGridSuccess(res, params);
          gridRef.current.resize();
        });

        // Count and totals depend only on the filter, not the scrolled page, so fetch them once
        // per filter (first block) instead of on every infinite-scroll block.
        if (params.startRow === 0) {
          const summaryReqParam = {
            ...viewerReqParam('AGGREGATES'),
            rowsReq: { expr },
          };
          rsrc.data(module, 'VIEWER_DATA_PLUGIN', summaryReqParam, 'SUB').then((summary) => {
            gridRef.current.setRowCount(summary.count);
            gridRef.current.setTotalsRow(summary.totals);
          });
        }
      },
    };

    gridRef.current.setDataSource(dataSource);
  };

  /* Refresh grid on change of filter expression */
  useEffect(() => {
    if (!gridRef.current || !selectedVal) return;
    onGridReady();
  }, [selectedVal]);

  useEffect(() => {
    if (!selectedVal) return;
    rsrc.data(module, 'VIEWER_DATA_PLUGIN', viewerReqParam('FIELD_DEFS'), 'SUB').then((fieldDefs) => {
      setFieldDefs(fieldDefs);
    });
  }, [selectedVal]);

  return (
    <Split direction="vertical" showSecondChild={!!fieldDefs?.length && !!selectedVal} initialSplit={40}>
      <ValList parentEntity="SUB" parentEntityId={parentEntityId} onSelect={handleSelect} />

      {fieldDefs && (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Grid ref={gridRef} gridOptions={{ fieldDefs }} events={{ onGridReady }} />
        </Box>
      )}
    </Split>
  );
};
